export default "__VITE_ASSET__CoUyJcc4__"